<template>
  <v-card
    @click="cardClick"
    :class="{ 'card-selected': selected }"
    elevation="0"
    outlined
  >
    <div class="d-flex align-start">
      <v-tooltip
        :disabled="!disableCheckbox"
        bottom
      >
      <template v-slot:activator="{ on, attrs }">
        <div v-on="on" v-bind="attrs">
          <v-checkbox
            :disabled="disableCheckbox"
            @click.stop="checkboxClick"
            :input-value="selected"
            class="mt-2 ml-4"
            dense
            readonly
          />
        </div>
        </template>
        <span>{{ disableTooltipText }}</span>
      </v-tooltip>
      <div class="flex-grow-1">
        <slot name="content"></slot>
      </div>
      <v-btn v-if="!disableOptions" @click.stop="moreClicked" class="mt-2 mr-1" icon small>
        <v-icon small>fa-solid fa-ellipsis-v</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<style scoped>
.card-selected {
  border-color: #118ACA;
  background-color: #EFF3F8;
}
</style>

<script>
export default {
  props: {
    selected: { type: Boolean, required: true },
    disableOptions: Boolean || null,
    disableCheckbox: Boolean || null,
    disableTooltipText: String
  },
  methods: {
    cardClick () {
      if (!this.disableCheckbox) {
        this.$emit('click:card')
      }
    },
    checkboxClick () {
      if (!this.disableCheckbox) {
        this.$emit('click:checkbox')
      }
    },
    moreClicked (event) {
      this.$emit('click:more', event)
    }
  }
}
</script>
